import { Injectable } from '@angular/core';
import { DatabaseService } from './database.service';
import { ConnectionService } from '../connection/connection.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private fileApiUrl = 'https://kraken.ibexfusion.com/get/';
  private shortUrlApiUrl = 'https://s.ipeak.info/new/';
  private shortUrlApiKey = 'dXQNUehu39BNdwNtaLkhwQKP6Q8tYQzY';

  constructor(private connection: ConnectionService, private db: DatabaseService) {
  }

  public getImage(url: string, forceLive = false, forceSave = false) {
    return this.getValue(url, 'image', forceLive, forceSave);
  }

  public getVideo(url: string, forceLive = false, forceSave = false) {
    return this.getValue(url, 'video', forceLive, forceSave);
  }

  public getShortUrl(url) {
    return this.getValue(url, 'shortUrl');
  }

  convertUrl(url: string, forceLive = false) {
    if (forceLive) {
      return url;
    }
    if (!!url && url.startsWith('http') && url.indexOf('tweebie-staging/assets') === -1 && url.indexOf('tweebie-staging.s3') === -1 && url.indexOf('https://ibexfusion5.s3') === -1) {
      return this.fileApiUrl + this.getBase64(url);
    }
    return url;
  }

  private async getValue(url: string, type = 'image', forceLive = false, forceSave = false): Promise<string> {
    if (!url) {
      return Promise.resolve(null);
    }
    if (type === 'image' || type === 'video') {
      if (!url.startsWith('http')) {
        if (!forceSave) {
          return Promise.resolve(url);
        }
      }
    }
    let result;
    try {
      result = await this.db.get(this.convertUrl(url, forceLive));
    } catch (err) {
      console.error('error: ', err);
      return url;
    }
    if (result) {
      if (type === 'image') {
        result = window.URL.createObjectURL(new Blob([result]));
        return result;
      } else if (type === 'shortUrl') {
        return result;
      } else if (type === 'video') {
        const videoBlob = this.base64ToBlob(result, 'video/mp4');
        return window.URL.createObjectURL(videoBlob);
      }
    } else {
      if (type === 'image') {
        let tempUrl = this.convertUrl(url, forceLive);
        let blob;
        try {
          blob = await fetch(tempUrl, { method: 'GET' }).then(res => res.blob());
        } catch (err) {
          console.warn('could not get image with url: ', this.convertUrl(url, forceLive), err);
        }
        let dataInDb;
        try {
          dataInDb = await this.db.put(this.convertUrl(url, forceLive), blob);
          console.log('image in DB:', dataInDb);
        } catch (err) {
          console.warn('could not put item to image db', url, err);
        }
        return tempUrl;
      } else if (type === 'shortUrl') {
        const result = await this.connection.getSimple(this.shortUrlApiUrl + encodeURIComponent(url) + '/' + this.shortUrlApiKey);
        let parsedResult = !!result['short_link'] ? result : (typeof result === 'string' ? JSON.parse((<any>result).text()) : null);
        if (!parsedResult['short_link']) {
          return null;
        }
        let shortUrl = parsedResult['short_link'];
        let dataInDb;
        try {
          dataInDb = await this.db.put(this.convertUrl(url), shortUrl);
          console.warn('short url in db', dataInDb);
        } catch (err) {
          console.error('error: ', err);
        }
        return url;
      } else if (type === 'video') {
        let tempUrl = this.convertUrl(url, forceLive);
        let blob;
        try {
          blob = await fetch(tempUrl, { method: 'GET' }).then(res => res.blob());
          const base64 = await this.blobToBase64(blob);
          let dataInDb;
          try {
            dataInDb = await this.db.put(this.convertUrl(url, forceLive), base64);
            console.log('video in DB:', dataInDb);
          } catch (err) {
            console.warn('could not put item to video db', url, err);
          }
        } catch (err) {
          console.warn('could not get video with url: ', this.convertUrl(url, forceLive), err);
        }
        return tempUrl;
      }
    }
  }

  private getBase64(value: string): string {
    value = btoa(value);
    return value.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });
  }

  base64ToBlob(base64, type) {
    const binary = atob(base64.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: type });
  }

}
